// export const FRENCH_PHONE_REGEX = /^(?:(?:\+33|0)[1-9])(?:\d{2}){4}$/;

// Only allow for 7 to 10 characters
export const PHONE_REGEX = /^[+]?[\d\s\-().]{7,10}$/;

export const FRENCH_SIREN_REGEX = /^\d{9}$/;

export const VIN_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/;

export const FRENCH_LICENSE_PLATE_NUMBER_REGEX = /^[A-Z]{2}-\d{3}-[A-Z]{2}$/;

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const EMPTY_HTML_TAG_REGEX =
  /<([a-zA-Z][a-zA-Z0-9]*)\s*[^>]*>(\s*(<br\s*\/?>)?\s*<\/\1>)?/g;

export const SPACE_REGEX = /\s+/g;

export const UUID_REGEX =
  /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9a-f]{24})$/i;
